import { render, staticRenderFns } from "./tiktok-order.vue?vue&type=template&id=40bae05c&"
import script from "./tiktok-order.vue?vue&type=script&lang=js&"
export * from "./tiktok-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports